import { SHContainer, SHStack } from "@components/design-systems";
import SHSkeleton from "@components/design-systems/sh-skeleton";
import {
  SHButtonSkeleton,
  SHDividerSkeleton,
} from "@components/skeletons/design-systems";
import { SHToggleButtonOptionsSkeleton } from "@components/skeletons/design-systems/SHToggleButtonOptionsSkeleton";
import { SHFieldGroupSkeleton } from "@components/skeletons/layouts";
import { StepNameSkeleton } from "@components/skeletons/layouts/stepper/StepNameSkeleton";

export const AnalysisFeeCalculatorSkeleton = () => {
  return (
    <SHContainer sx={{ px: { xs: "16px", lg: 0 }, py: "25px" }}>
      <SHStack gap={4}>
        <StepNameSkeleton delay={false} />

        <SHStack spacing={2}>
          <SHSkeleton width={80} height={26} delay={false} />
          <SHStack gap={1}>
            <SHSkeleton width={"100%"} height={22} delay={false} />
            <SHSkeleton width={"90%"} height={22} delay={false} />
          </SHStack>
        </SHStack>

        <SHDividerSkeleton delay={false} />

        <SHFieldGroupSkeleton
          leftSide={
            <SHStack width={"40%"} spacing={1}>
              <SHSkeleton height={18} width={"50%"} delay={false} />
              {Array.from(Array(3)).map((_, index) => (
                <SHSkeleton
                  key={index}
                  height={16}
                  width={"100%"}
                  delay={false}
                />
              ))}
            </SHStack>
          }
          rightSide={
            <SHStack width={{ xs: "100%", md: 520 }} spacing={3}>
              <SHSkeleton width={"100%"} height={100} delay={false} />
              <SHButtonSkeleton width={160} delay={false} />
              <SHSkeleton width={"100%"} height={54} delay={false} />
            </SHStack>
          }
        />

        <SHDividerSkeleton delay={false} />

        <SHFieldGroupSkeleton
          leftSide={
            <SHStack width={"40%"} spacing={1}>
              <SHSkeleton height={18} width={"50%"} delay={false} />
              {Array.from(Array(4)).map((_, index) => (
                <SHSkeleton
                  key={index}
                  height={16}
                  width={"100%"}
                  delay={false}
                />
              ))}
              <SHSkeleton height={16} width={"30%"} delay={false} />
            </SHStack>
          }
          rightSide={
            <SHStack width={"520px"}>
              <SHToggleButtonOptionsSkeleton width={"300px"} />
            </SHStack>
          }
        />

        <SHDividerSkeleton delay={false} />

        <SHFieldGroupSkeleton
          leftSide={
            <SHStack width={"40%"} spacing={1}>
              <SHSkeleton height={18} width={"50%"} delay={false} />
              {Array.from(Array(2)).map((_, index) => (
                <SHSkeleton
                  key={index}
                  height={16}
                  width={"100%"}
                  delay={false}
                />
              ))}
            </SHStack>
          }
          rightSide={
            <SHStack width={"520px"} gap={3}>
              {Array.from(Array(6)).map((_, index) => (
                <SHStack key={index} direction={"row"} spacing={1}>
                  <SHSkeleton height={20} width={20} delay={false} />
                  <SHSkeleton height={20} width={"70%"} delay={false} />
                </SHStack>
              ))}
            </SHStack>
          }
        />

        <SHDividerSkeleton delay={false} />

        <SHFieldGroupSkeleton
          leftSide={
            <SHStack width={"40%"} spacing={1}>
              <SHSkeleton height={18} width={"50%"} delay={false} />
              {Array.from(Array(2)).map((_, index) => (
                <SHSkeleton
                  key={index}
                  height={16}
                  width={"100%"}
                  delay={false}
                />
              ))}
            </SHStack>
          }
          rightSide={
            <SHStack width={"520px"} gap={2}>
              <SHStack direction={"row"} width={"100%"} spacing={2}>
                <SHStack spacing={1.5} width={"50%"}>
                  <SHSkeleton height={18} width="30%" delay={false} />
                  <SHSkeleton height={35} width="100%" delay={false} />
                </SHStack>

                <SHStack spacing={1.5} width={"50%"}>
                  <SHSkeleton height={18} width="30%" delay={false} />
                  <SHSkeleton height={35} width="100%" delay={false} />
                </SHStack>
              </SHStack>

              <SHStack direction={"row"} width={"100%"} spacing={2}>
                <SHStack spacing={1.5} width={"50%"}>
                  <SHSkeleton height={18} width="30%" delay={false} />
                  <SHSkeleton height={35} width="100%" delay={false} />
                </SHStack>

                <SHStack spacing={1.5} width={"50%"}>
                  <SHSkeleton height={18} width="30%" delay={false} />
                  <SHSkeleton height={35} width="100%" delay={false} />
                </SHStack>
              </SHStack>
            </SHStack>
          }
        />
      </SHStack>
    </SHContainer>
  );
};
